<div *ngIf="isLoading" class="ui basic segment loading"></div>
<ng-container *ngIf="!isLoading">
    <ui-banner class="margin-bottom-4" *ngIf="!company.primaryAddressId" variant="info">
        <div>
            <p>{{ 'self-serve.payYourTeam.addYourOfficeFirst' | translate }}</p>
            <p class="margin-top-1">
                <a [routerLink]="'../company-profile'">{{ 'self-serve.payYourTeam.addOfficeAddress' | translate }}</a>
            </p>
        </div>
    </ui-banner>
    <app-header *ngIf="!addedEmployeeCount" title="self-serve.payYourTeam.addYourTeam"></app-header>
    <app-header *ngIf="addedEmployeeCount === 1" title="self-serve.payYourTeam.wellDoneYouHaveAdded1"></app-header>
    <app-header
        *ngIf="addedEmployeeCount > 1"
        [title]="'self-serve.payYourTeam.wellDoneYouHaveAddedMany' | translate: { number: addedEmployeeCount }"
    >
    </app-header>
    <p class="text-color-secondary-font margin-bottom-6">
        {{ 'self-serve.payYourTeam.makeSureYourEmployees' | translate }}
    </p>

    <div class="new-employee-links">
        <ui-card
            variant="dark"
            [clickable]="true"
            [disabled]="!company.primaryAddressId"
            role="link"
            [routerLink]="'new'"
        >
            <h3 class="margin-bottom-1">{{ 'self-serve.payYourTeam.addEmployee' | translate }}</h3>
            <p class="text-color-secondary-font">{{ 'self-serve.payYourTeam.addEmployeeDetails' | translate }}</p>
        </ui-card>
        <ui-card
            variant="dark"
            [clickable]="true"
            [disabled]="!company.primaryAddressId"
            role="link"
            [routerLink]="'new-terminated'"
        >
            <h3 class="margin-bottom-1">{{ 'self-serve.payYourTeam.addTerminatedEmployee' | translate }}</h3>
            <p class="text-color-secondary-font">
                {{ 'self-serve.payYourTeam.addTerminatedEmployeeDetails' | translate }}
            </p>
        </ui-card>
    </div>

    <app-table
        *ngIf="table"
        [table]="table"
        (menuItemSelected)="menuAction($event)"
        [isResponsive]="true"
        [showOffset]="true"
        [noPadding]="true"
        [embedded]="true"
    >
        <app-empty-state label="employees.directory.noEmployeesFound" src="/assets/illustrations/magnifying-glass.png">
        </app-empty-state>
    </app-table>

    <div class="flex buttons justify-end">
        <ui-button
            *ngIf="notYetInvitedEmployees.length || !addedEmployeeCount"
            type="outline"
            (click)="trackSelfServeAddTeamClickLater()"
            >{{ 'self-serve.iWillDoItLater' | translate }}</ui-button
        >
        <ui-button
            *ngIf="notYetInvitedEmployees.length"
            type="primary"
            (click)="sendInvites()"
            [disabled]="isSendingInvites"
            >{{ 'self-serve.payYourTeam.sendInviteToEmployees' | translate }}</ui-button
        >
    </div>
</ng-container>
